import { createContext, useContext } from 'react';

import type { TPermissions } from '@modules/core/types';

// Context for router state
export interface RouterContextType {
  isReady: boolean;
  userPermissions: TPermissions;
}

export const RouterContext = createContext<RouterContextType | undefined>(undefined);

export const useRouterContext = () => {
  const context = useContext(RouterContext);
  if (context === undefined) {
    throw new Error('useRouterContext must be used within a RouterProvider');
  }
  return context;
};
